var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('rect',{attrs:{"x":"8.5","y":"8.5","width":"7","height":"7","rx":"1","fill":"currentColor"}})])}
var staticRenderFns = []

export { render, staticRenderFns }